<template>
	<div class="flex-row flex-just-between">
		<div class="flex-row-align-center">
			<el-date-picker
				v-if="showMoreCuttent"
				style="width: 250px"
				class="ml-10"
				:clearable="false"
				size="small"
				@change="handlePickerChange"
				@blur="handlePickerBlur"
				v-model="pickerValue"
				type="daterange"
				value-format="timestamp"
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期"
				:picker-options="pickerOptions"
				:default-time="['00:00:00', '23:59:59']"
			></el-date-picker>
			<span class="color-gy-7 fz-12 ml-16 cursor-pointer" @click="skipUrl" v-if="showMore">
				更多
				<i class="el-icon-arrow-right"></i>
			</span>
		</div>
	</div>
</template>

<script>
import { startOfDay, endOfDay, startOfWeek, endOfWeek, endOfMonth, startOfMonth, subWeeks, subMonths, getDate, getDay, subDays } from 'date-fns';
import { calDate } from '@/utils/common';
import { debounce } from 'lodash';

export default {
	props: {
		showMore: {
			type: Boolean,
			default: false,
		},
		showMoreCuttent: {
			type: Boolean,
			default: false,
		},
		cuttentToadyEnd: {
			// 自定义时间选择中 是否可以现在今天之后的时间， 也就是包括明天及以后都不可选择
			type: Boolean,
			default: false,
		},
		cuttentContainTodat: {
			// 自定义的时间列表中 是否可以选择今天
			type: Boolean,
			default: false,
		},
		cuttentMaxDay: {
			// 自定义筛选可选择的最远时间
			// 例如首页只能选择180天以内的
			// 以天为单位
			type: Number,
			default: 0,
		},
		cycle: {
			// 可选范围 例如首页最大可选两个月
			// 以天为单位
			type: Number,
			default: 0,
		},
		morePath: {
			type: Object,
			default: () => {
				return {
					path: '',
					query: {},
				};
			},
		},
		value: {
			type: Number,
			default: 7,
		},
	},
	data() {
		return {
			typeValue: null,
			str: '',
			start_time: null,
			end_time: null,

			pickerValue: [],

			cuttentTime: '',
			pickerOptions: {
				maxTime: this.cuttentMaxDay * 24 * 3600 * 1000,
				cycle: this.cycle * 24 * 3600 * 1000,
				yesterday: this.cuttentContainTodat
					? Number(endOfDay(new Date())) + (this.cuttentToadyEnd ? 315360000000 : 0)
					: Number(endOfDay(subDays(new Date(), 1))) + (this.cuttentToadyEnd ? 315360000000 : 0),
				today: startOfDay(new Date()),
				onPick: ({ maxDate, minDate }) => {
					this.cuttentTime = minDate.getTime();
					if (maxDate) {
						this.cuttentTime = '';
					}
				},
				disabledDate: time => {
					const timeDate = time.getTime();
					if (this.cuttentTime != '') {
						if (this.cuttentMaxDay == 0 && this.cycle == 0) {
							// 不限制选择周期 和 最远时间
							return Number(timeDate) > this.pickerOptions.yesterday;
						}
						const maxDate = this.pickerOptions.today - this.pickerOptions.maxTime;
						let startTime = this.cuttentTime - this.pickerOptions.cycle;
						let endTime = this.cuttentTime + this.pickerOptions.cycle;

						if (this.cycle != 0 && this.cuttentMaxDay != 0) {
							startTime = Number(startTime) > Number(maxDate) ? startTime : maxDate;
							endTime = Number(endTime) > this.pickerOptions.yesterday ? this.pickerOptions.yesterday : endTime;
						}
						if (this.cycle == 0 && this.cuttentMaxDay != 0) {
							startTime = maxDate;
							endTime = this.pickerOptions.yesterday;
						}
						if (this.cuttentMaxDay == 0 && this.cycle != 0) {
							startTime = this.cuttentTime - this.pickerOptions.cycle;
							endTime = this.pickerOptions.yesterday;
						}
						return Number(timeDate) < Number(startTime) || Number(timeDate) > Number(endTime);
					}
					if (this.cuttentMaxDay == 0) {
						// 不限制最远时间
						return Number(timeDate) > this.pickerOptions.yesterday;
					}
					return Number(timeDate) > this.pickerOptions.yesterday || this.pickerOptions.today - timeDate > this.pickerOptions.maxTime;
				},
				shortcuts: [
					{
						text: '昨日',
						onClick: picker => {
							this.handleCommandType(1);
						},
					},
					{
						text: '近7天',
						onClick: picker => {
							this.handleCommandType(7);
						},
					},
					{
						text: '近30天',
						onClick: picker => {
							this.handleCommandType(30);
						},
					},
					{
						text: '本周',
						onClick: picker => {
							this.handleCommandType('week');
						},
					},
					{
						text: '本月',
						onClick: picker => {
							this.handleCommandType('month');
						},
					},
				],
			},
		};
	},
	created() {
		this.handleCommandTypeOrigin(this.value, true);
		this.handleCommandType = debounce(this.handleCommandTypeOrigin, 300);
	},
	methods: {
		skipUrl() {
			const { path, query } = this.morePath;
			const handLink = this.$router.resolve({
				path,
				query: query || {},
			});
			window.open(handLink.href, '_blank');
		},
		handleCommandTypeOrigin(type, isInit) {
			this.typeValue = type;
			if (typeof type == 'number') {
				const { start_time, end_time } = this.setTimeText(type);
				this.start_time = start_time;
				this.end_time = end_time;
				this.str = type;
				this.pickerValue = [start_time * 1000, end_time * 1000];
				!isInit && this.$emit('change', { start_time, end_time, str: type });
			} else {
				const today = new Date();
				if (type == 'week') {
					this.str = 2;
					if (getDay(today) == 1) {
						const start_time = Math.trunc(startOfWeek(subWeeks(today, 1), { weekStartsOn: 1 }).valueOf() / 1000);
						const end_time = Math.trunc(endOfWeek(subWeeks(today, 1), { weekStartsOn: 1 }).valueOf() / 1000);
						!isInit &&
							this.$emit('change', {
								start_time: start_time,
								end_time: end_time,
								str: this.str,
							});
						this.start_time = start_time;
						this.end_time = end_time;
						this.pickerValue = [start_time * 1000, end_time * 1000];
					} else {
						const start_time = Math.trunc(startOfWeek(today, { weekStartsOn: 1 }).valueOf() / 1000);
						const end_time = Math.trunc(endOfDay(subDays(today, 1)).valueOf() / 1000);
						!isInit &&
							this.$emit('change', {
								start_time: start_time,
								end_time: end_time,
								str: this.str,
							});
						this.start_time = start_time;
						this.end_time = end_time;
						this.pickerValue = [start_time * 1000, end_time * 1000];
					}
				}
				if (type == 'month') {
					this.str = 4;
					if (getDate(today) == 1) {
						const start_time = Math.trunc(startOfMonth(subMonths(today, 1)).valueOf() / 1000);
						const end_time = Math.trunc(endOfMonth(subMonths(today, 1)).valueOf() / 1000);
						!isInit &&
							this.$emit('change', {
								start_time: start_time,
								end_time: end_time,
								str: this.str,
							});
						this.start_time = start_time;
						this.end_time = end_time;
						this.pickerValue = [start_time * 1000, end_time * 1000];
					} else {
						const start_time = Math.trunc(startOfMonth(today).valueOf() / 1000);
						const end_time = Math.trunc(endOfDay(subDays(today, 1)).valueOf() / 1000);
						!isInit &&
							this.$emit('change', {
								start_time: start_time,
								end_time: end_time,
								str: this.str,
							});
						this.start_time = start_time;
						this.end_time = end_time;
						this.pickerValue = [start_time * 1000, end_time * 1000];
					}
				}
			}
		},
		setTimeText(value) {
			const today = new Date();
			const [start_time, end_time] = !value ? [startOfDay(today), endOfDay(today)] : calDate(value);
			return {
				start_time: Math.trunc(start_time / 1000),
				end_time: Math.trunc(end_time / 1000),
			};
		},
		reset() {
			this.handleCommandTypeOrigin(this.value, true);
		},

		handlePickerChange(e) {
			// 侧边便捷选择也会触发 chenge， 这种情况会触发两次
			if (e[0] / 1000 != this.start_time || e[1] / 1000 != this.end_time) {
				this.$emit('change', {
					start_time: this.pickerValue[0] / 1000,
					end_time: this.pickerValue[1] / 1000,
					str: this.str,
				});
				this.start_time = this.pickerValue[0] / 1000;
				this.end_time = this.pickerValue[1] / 1000;
				this.typeValue = null;
			}
		},
		handlePickerBlur() {
			if (this.cuttentTime) {
				this.cuttentTime = '';
			}
		},
	},
};
</script>

<style lang="less" scoped>
.blockTitle-border {
	border: 1px solid #e2e3e8;
	height: 30px;
}
.blockTitle-border-left {
	border-left: 1px solid #e2e3e8;
}
</style>
